import { ProductionJob } from "@models/review/production-job.model";
import { ProductionJobView } from "@models/ui/production-job-view.model";
import { MapperBase } from "src/app/utilities/mapper-base";

export class ProductionJobToProductionJobViewMapper extends MapperBase<ProductionJob, ProductionJobView>{
    public map(source: ProductionJob): ProductionJobView {
        const dest = new ProductionJobView();
        dest.productionJobId = source.productionJobId;
        dest.caseId = source.caseId;
        dest.createdById = source.createdById;
        dest.runById = source.runById;
        dest.title = source.title;
        dest.comments = source.comments;
        dest.dateTimeCreated = source.dateTimeCreated;
        dest.dateTimeRun = source.dateTimeRun;
        dest.batesBasePrefix = source.batesBasePrefix;
        dest.batesBaseNumberStart = source.batesBaseNumberStart;
        dest.batesBaseNumberDigits = source.batesBaseNumberDigits;
        dest.customDesignation = source.customDesignation;
        dest.isBatesStampPages = source.isBatesStampPages;
        dest.isControlNumberStampPages = source.isControlNumberStampPages;
        dest.isCreateTiff = source.isCreateTiff;
        dest.docSizeProduced = source.docSizeProduced;
        dest.docSizeWithheld = source.docSizeWithheld;
        dest.batesRangeProduction = source.batesRangeProduction;
        dest.batesRangeWithheld = source.batesRangeWithheld;
        dest.lifecycle = source.lifecycle;
        dest.status = source.status;
        dest.isIncludeNativeEmails = source.isIncludeNativeEmails;
        dest.sortId = source.sortId;
        dest.sortLevel1 = source.sortLevel1;
        dest.sortLevel2 = source.sortLevel2;
        dest.level1FieldId = source.level1FieldId;
        dest.totalDocCount = source.totalDocCount;
        dest.producedDocCount = source.producedDocCount;
        dest.withheldDocCount = source.withheldDocCount;
        dest.partiallyPrivilegedDocCount = source.partiallyPrivilegedDocCount;
        return dest;
    }
}